<ion-item>
  <ion-icon [name]="selectNavigationTool.icon" slot="start" size="large"></ion-icon>
  <ion-select
    (ionChange)="selectNavigationTool.change($event.detail.value)"
    value="{{ selectNavigationTool.current }}"
    [okText]="'Mobile.OK' | translate"
    [cancelText]="'Mobile.Cancel' | translate"
    label-placement="floating"
  >
    <ion-label slot="label" *ngIf="!selectNavigationTool.current" translate> {{ selectNavigationTool.text }}</ion-label>
    <ion-select-option *ngFor="let destination of selectNavigationTool.values" value="{{ destination.ResAddressUid }}">
      {{ destination.Name }}
    </ion-select-option>
  </ion-select>
</ion-item>
